// extracted by mini-css-extract-plugin
export default {"recos":"c6-z","productCardOverride":"d6-z","rowHasBadge":"e6-z"};